import React from "react";

import { templates } from "@reactivated";

import { TrackOrderSummary } from "../apps/customer-account/TrackOrderSummary";

export const Template = (
    props: templates.TrackOrderSummaryTemplate,
): React.JSX.Element => {
    return <TrackOrderSummary {...props} />;
};
